var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22965_166896)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_22965_166896)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21487 10.6936C3.19326 10.7686 3.21487 10.8507 3.26957 10.9055C3.30992 10.9457 3.36614 10.9688 3.4223 10.9688C3.44245 10.9688 3.46265 10.9659 3.48139 10.9602L5.49534 10.3854L3.78966 8.67969L3.21487 10.6936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42229 10.9753C3.3632 10.9753 3.30704 10.9523 3.26529 10.9105C3.20766 10.8529 3.18605 10.7693 3.20907 10.6916L3.78819 8.66602L5.5112 10.389L3.48279 10.9667C3.46264 10.9725 3.44244 10.9753 3.42229 10.9753ZM3.79399 8.69196L3.22207 10.6944C3.20187 10.7679 3.22207 10.8457 3.27536 10.899C3.31425 10.9379 3.36754 10.9595 3.42229 10.9595C3.44103 10.9595 3.46118 10.9566 3.47992 10.9509L5.48239 10.379L3.79399 8.69196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.379 4.71139L9.46424 3.7966C9.34038 3.67414 9.17904 3.60645 9.0047 3.60645C8.83182 3.60645 8.66902 3.67414 8.54657 3.79519L8.08844 4.25326L9.9195 6.08432L10.3776 5.62619C10.5001 5.50374 10.5663 5.34093 10.5663 5.16806C10.5678 4.99518 10.5001 4.83385 10.379 4.71139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92096 6.09476L8.07983 4.25363L8.54224 3.79122C8.66616 3.66731 8.83037 3.59961 9.0047 3.59961C9.18045 3.59961 9.34471 3.66731 9.46717 3.79122L10.382 4.70602C10.5058 4.82988 10.5735 4.99415 10.5735 5.16843C10.5735 5.34423 10.5058 5.50844 10.382 5.63089L9.92096 6.09476ZM8.09998 4.25363L9.92096 6.07461L10.3733 5.62222C10.4943 5.50123 10.5606 5.3413 10.5606 5.16989C10.5606 4.99848 10.4943 4.83855 10.3733 4.71756L9.4585 3.8013C9.33751 3.68031 9.17612 3.61402 9.0047 3.61402C8.83329 3.61402 8.67336 3.68031 8.55237 3.8013L8.09998 4.25363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03275 8.31035L7.78445 4.55859L9.61601 6.39016L5.86431 10.1419L4.03275 8.31035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86414 10.1529L4.02161 8.31032L7.78451 4.54883L9.62564 6.38996L5.86414 10.1529ZM4.04322 8.31032L5.86414 10.1312L9.60543 6.38996L7.78451 4.56903L4.04322 8.31032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25201 10.9154C3.35588 10.9165 4.81505 10.4969 4.93215 10.4742C5.49515 10.3546 6.12115 10.0251 7.01359 9.40195C7.08287 9.35358 7.24246 9.23988 7.4148 9.11701L7.58852 8.99317C7.76074 8.87042 7.91987 8.75723 7.98834 8.70972C8.35569 8.45484 8.62476 8.28937 8.86692 8.18006C9.52602 7.88257 10.0537 8.27266 9.80162 8.94056C9.71895 9.1596 9.57082 9.40987 9.28855 9.83447C10.2785 9.44975 11.2903 9.25378 12.0269 9.37046C12.2816 9.41079 12.4554 9.64996 12.4151 9.90465C12.3747 10.1593 12.1356 10.3331 11.8809 10.2928C11.1107 10.1708 9.75736 10.5519 8.63861 11.1647C8.30614 11.3468 8.07146 11.4012 7.83013 11.1022C7.63646 10.8623 7.67985 10.6849 7.8222 10.3972C7.91017 10.2193 7.97906 10.1095 8.29858 9.63392L8.09061 9.78204L7.94454 9.88618C7.77567 10.0066 7.61912 10.1181 7.5482 10.1676C6.55386 10.8619 5.8312 11.251 5.10992 11.3909C4.40192 11.5282 3.76722 11.3834 3.25201 10.9154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22965_166896",
    x1: 1.12775,
    y1: 1.68364,
    x2: 1.12775,
    y2: 15.4281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22965_166896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigning);
export default __webpack_public_path__ + "static/media/signing.b8399a20fc2d0ff8976e8df3b7207a56.svg";
export { ForwardRef as ReactComponent };